import { useLocalStorage } from '@vueuse/core';

import { captureException } from '@/wabunka-src/common/utils/sentry';
import { WABUNKA_EXPERIENCE_BROWSING_HISTORY } from '@/wabunka-src/constants/wabunkaLocalStorageKeys';

const MAX_HISTORY_SIZE = 15;

const fetchWabunkaExperienceBrowsingHistories = (): string[] => {
  if (process.server) return [];

  try {
    if (!localStorage) return [];

    const histories = localStorage.getItem(WABUNKA_EXPERIENCE_BROWSING_HISTORY);
    if (histories) {
      return histories.split(',');
    }

    return [];
  } catch (error) {
    captureException(error);
    return [];
  }
};

const deleteSameExperienceIfBrowsed = (histories: string[], slug: string) => {
  const index = histories.indexOf(slug);
  if (index !== -1) {
    return histories.splice(index, 1);
  }
};

const deleteOldestExperienceIfOverMaxHistorySize = (histories: string[]) => {
  if (histories.length > MAX_HISTORY_SIZE) {
    histories.pop();
  }
};

export const useAddWabunkaExperienceBrowsingHistory = () => {
  const addExperienceBrowsingHistory = (slug: string) => {
    const histories = fetchWabunkaExperienceBrowsingHistories();
    if (!histories) return;

    // 過去に同じ体験を閲覧していたら、それのslugは消して先頭に再追加
    deleteSameExperienceIfBrowsed(histories, slug);
    histories.unshift(slug);

    // 上限に達したら古いものから削除
    deleteOldestExperienceIfOverMaxHistorySize(histories);

    try {
      const history = useLocalStorage(WABUNKA_EXPERIENCE_BROWSING_HISTORY, '');
      history.value = histories.toString();
    } catch (error) {
      captureException(error);
    }
  };

  return { addExperienceBrowsingHistory };
};
